import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {DataContext} from "../shared/DataContext";

const Logout = () => {
    const navigate = useNavigate();
    const { setCurrentUser } = useContext(DataContext);

    useEffect(() => {
        const logout = async () => {
            try {
                await axios.post('/api/logout');
                setCurrentUser(null);
                navigate('/');
            } catch (err) {
                console.error('Logout error:', err);
            }
        };

        logout();
    }, [navigate]);

    return null;
};

export default Logout;
